export const HOME = '/carryout/ordertrack';  
// https://gpstracker.dominos.com.my/carryout/ordertrack?storeId=96935&orderId=618&date=20200313
export const NOTFOUND = '/404';
